<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Transaction Details</h3>
    </div>
  </div>
  <div style="max-height: 400px" class="ks-scrollbar-neutral">
    <div class="card-body" *ngIf="transactionMode">
      <div class="transaction-details-section ks-bg-lighter-neutral ks-p-5">
        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-mb-0 ks-label-md ks-text-neutral ks-font-weight-medium">
              Transaction amount
            </p>
            <p
              class="line-height-26 ks-font-size-xl ks-heading-font-family ks-font-weight-bold ks-mb-2 ks-pb-6 ks-border-bottom-regular-solid ks-border-light-neutral"
            >
              ${{ data.transaction.amount }}.00
            </p>
          </div>
        </div>
        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-mb-0 ks-label-md ks-text-neutral ks-font-weight-medium">Status</p>
          </div>
          <div class="ks-col status-column">
            <div
              style="width: 140px"
              class="ks-badge-md ks-badge-light-{{
                getTransactionStatusColor(data.transaction.status)
              }}"
            >
              {{ data.transaction.status | enumFormat : '_' }}
            </div>
          </div>
        </div>

        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Customer</p>
          </div>
          <div class="ks-col status-column">
            <p class="ks-neutral-darker ks-font-weight-medium ks-font-size-sm">
              {{ getContactName(data.transaction.customer_id) }}
            </p>
          </div>
        </div>

        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Payment method</p>
          </div>
          <div class="ks-col status-column">
            <p class="ks-neutral-darker ks-font-weight-medium ks-font-size-sm">
              {{ getPaymentMethod(data.transaction) }}
            </p>
          </div>
        </div>

        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Payment code</p>
          </div>
          <div class="ks-col status-column">
            <p class="ks-text-1lns ks-neutral-darker ks-font-weight-medium ks-font-size-sm">
              {{ data.transaction.payment_code }}
            </p>
          </div>
        </div>

        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Date and time</p>
          </div>
          <div class="ks-col status-column">
            <p class="ks-neutral-darker ks-font-weight-medium ks-font-size-sm">
              {{ data.transaction.transaction_date | date : 'dd MMM yyyy' }} at
              {{ data.transaction.transaction_date | date : 'hh:mm a' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" *ngIf="voided">
      <div class="ks-bg-lighter-danger ks-p-5">
        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-mb-0 ks-label-md ks-text-neutral ks-font-weight-medium">Status</p>
          </div>
          <div class="ks-col status-column">
            <div style="width: 140px" class="ks-badge-md ks-badge-danger">Voided</div>
          </div>
        </div>
        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Payment code</p>
          </div>
          <div class="ks-col status-column">
            <p class="ks-text-1lns ks-neutral-darker ks-font-weight-medium ks-font-size-sm">
              {{ data.transaction.payment_code }}
            </p>
          </div>
        </div>
        <div class="ks-row ks-mb-4">
          <div
            class="ks-col ks-pb-6 ks-border-bottom-regular-solid ks-border-light-neutral ks-p-0 ks-ml-5"
          >
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Date and time</p>
          </div>
          <div
            class="ks-col ks-border-bottom-regular-solid ks-border-light-neutral status-column ks-p-0 ks-mr-5"
          >
            <p class="ks-neutral-darker ks-font-weight-medium ks-font-size-sm">
              {{ data.transaction.transaction_date | date : 'dd MMM yyyy' }} at
              {{ data.transaction.transaction_date | date : 'hh:mm a' }}
            </p>
          </div>
        </div>

        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-text-neutral ks-font-weight-medium ks-font-size-sm">Processed by</p>
          </div>
          <div class="ks-col status-column">
            <p class="ks-neutral-darker ks-font-weight-medium ks-font-size-sm">Admin</p>
          </div>
        </div>

        <div class="ks-row ks-mb-4">
          <div class="ks-col">
            <p class="ks-mb-0 ks-label-md ks-text-neutral ks-font-weight-medium">Reason</p>
            <p class="line-height-26 ks-font-size-sm ks-heading-font-family ks-font-weight-bold">
              {{ data.transaction.void_reason }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      class="ks-btn-sm ks-btn-outline-neutral ks-mr-2"
      *ngIf="transactionMode"
      (click)="onClose()"
    >
      Close
    </button>
    <button
      class="ks-btn-sm ks-btn-danger"
      *ngIf="transactionMode && !voided && data.transaction.status === 'Completed'"
      (click)="voidTransaction()"
    >
      Void transaction
    </button>
  </div>
</div>
